(function () {
  function resetCarouselDrag(carousel) {
    if (!carousel || carousel.getAttribute('data-dragging') !== 'true') return;

    var container = carousel.querySelector('.card-carousel--container');
    carousel.swipe_state = 'swipe-ended';
    carousel.slide_pause = false;
    carousel.ticking = false;

    if (typeof carousel.dragEnd === 'function') {
      carousel.dragEnd();
    } else {
      carousel.setAttribute('data-dragging', 'false');
      window.Drawer && (window.Drawer.disable_swipe_listener = false);
    }

    if (container) {
      container.setAttribute('data-transition-state', 'forwards');
    }

    if (carousel.container_destination) {
      carousel.style.setProperty('--slide-pos', carousel.container_destination);
    }
  }

  function resetAllCarouselDrags() {
    document.querySelectorAll('card-carousel[data-dragging="true"]').forEach(resetCarouselDrag);
  }

  function disableNativeCarouselDrag(carousel) {
    if (!carousel) return;

    carousel.querySelectorAll('img, a').forEach(function (element) {
      element.setAttribute('draggable', 'false');
    });
  }

  function disableAllNativeCarouselDrags() {
    document.querySelectorAll('card-carousel').forEach(disableNativeCarouselDrag);
  }

  window.addEventListener('mouseup', function () {
    setTimeout(resetAllCarouselDrags, 0);
  });
  window.addEventListener('touchend', function () {
    setTimeout(resetAllCarouselDrags, 0);
  });
  window.addEventListener('touchcancel', resetAllCarouselDrags, true);
  window.addEventListener('dragend', resetAllCarouselDrags, true);
  window.addEventListener('drop', resetAllCarouselDrags, true);
  window.addEventListener('blur', resetAllCarouselDrags);
  document.addEventListener('mouseleave', resetAllCarouselDrags);
  document.addEventListener('visibilitychange', function () {
    if (document.hidden) resetAllCarouselDrags();
  });

  document.addEventListener('shopify:section:select', function () {
    resetAllCarouselDrags();
    disableAllNativeCarouselDrags();
  });
  document.addEventListener('shopify:section:load', function () {
    resetAllCarouselDrags();
    disableAllNativeCarouselDrags();
  });
  document.addEventListener('shopify:block:select', function () {
    resetAllCarouselDrags();
    disableAllNativeCarouselDrags();
  });
  document.addEventListener('dragstart', function (event) {
    if (event.target.closest('card-carousel')) {
      event.preventDefault();
    }
  }, true);

  disableAllNativeCarouselDrags();

  new MutationObserver(disableAllNativeCarouselDrags).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
